import { render, staticRenderFns } from "./WorkOrderList.vue?vue&type=template&id=4124e6c0&scoped=true"
import script from "./WorkOrderList.vue?vue&type=script&lang=js"
export * from "./WorkOrderList.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderList.vue?vue&type=style&index=0&id=4124e6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4124e6c0",
  null
  
)

export default component.exports